import apiConfig from "../../config/apiConfig";
import apiConfigWthFormData from "../../config/apiConfigWthFormData";
import { URL } from "../../routers/constants";
import { objToQueryString, randomCampaignName, showSuccessToasts } from "../../services/helpers/Helper";
import { CAMPAIGN_TYPE, END_POINT } from "../constants";
import { setError } from "./errorAction";
import { hideLoading, showLoading } from "./loadingAction";

export const fetchCampaign = (currentPage = 1, page_size = 10) =>
  async (dispatch, getState) => {
    const { page } = getState();
    const params = {
      fb_page_id: page.social_id,
      clientType: '',
      revision: '',
      languageCode: '',
      countryCode: '',
      timestamp: new Date().getTime(),
      page: currentPage,
      page_size,
      campaign_cate: 1
    }
    const qs = objToQueryString(params);
    const endPoint = `${END_POINT.LIST_CAMPAIGNS}?${qs}`;
    dispatch(showLoading());
    apiConfig.get(endPoint).then((response) => {
      dispatch({
        type: CAMPAIGN_TYPE.FETCHS,
        payload: response.data
      })
    }).catch((error) => {
      dispatch(setError(error.message));
    }).finally(() => {
      dispatch(hideLoading());
    });
  };

export const createCampaign = (navigate) =>
  async (dispatch, getState) => {
    const { page } = getState();
    const params = {
      fb_page_id: page.social_id,
      clientType: '',
      revision: '',
      languageCode: '',
      countryCode: '',
      timestamp: new Date().getTime(),
      campaign_name: randomCampaignName(),
      campaign_cate: 1
    }
    dispatch(showLoading());
    apiConfig.post(END_POINT.PAGE_CAMPAIGNS, params).then((response) => {
      const { data: id } = response;
      const url = URL.POSTS_COMMENTS_SALE_POSTS_CAMPAIGN_EDIT.replace(':id', id);
      navigate(url);
    }).catch((error) => {
      dispatch(setError(error.message));
    }).finally(() => {
      dispatch(hideLoading());
    });
  }

export const updateCampaign = (campaign) =>
  async (dispatch) => {
    dispatch(showLoading());
    apiConfig.post(END_POINT.PAGE_CAMPAIGNS, campaign).then((response) => {
      dispatch({
        type: CAMPAIGN_TYPE.UPDATE,
        payload: campaign
      })
    }).finally(() => {
      dispatch(hideLoading());
    });
  }

export const detailCampaign = (id) =>
  async (dispatch) => {
    dispatch(showLoading());
    const params = {
      campaign_id: id,
      clientType: '',
      revision: '',
      languageCode: '',
      countryCode: '',
      timestamp: new Date().getTime(),
    }
    const qs = objToQueryString(params);
    const endPoint = `${END_POINT.PAGE_CAMPAIGN_DETAILS}?${qs}`;
    apiConfig.get(endPoint).then((response) => {
      const { data } = response;
      dispatch({
        type: CAMPAIGN_TYPE.FETCH,
        payload: data
      });
    }).catch((error) => {
      dispatch(setError(error.message));
    }).finally(() => {
      dispatch(hideLoading());
    });
  }


export const addPostCampaign = (posts) =>
  async (dispatch) => {
    dispatch(showLoading());
    apiConfig.post(END_POINT.ADD_POSTS_CAMPAIGN, posts).then(() => {
      const id = posts?.[0]?.campaigns_manage_id;
      if (id) {
        dispatch(fetchListPostCampaign(id));
      }
    }).catch((error) => {
      dispatch(setError(error.message))
    }).finally(() => {
      dispatch(hideLoading());
    });
  };

export const fetchListPostCampaign = (campaign_id) =>
  async (dispatch, getState) => {
    const { page } = getState();
    const params = {
      fb_page_id: page.social_id,
      campaign_id,
      clientType: '',
      revision: '',
      languageCode: '',
      countryCode: '',
      timestamp: new Date().getTime()
    }
    const qs = objToQueryString(params);
    const endPoint = `${END_POINT.LIST_POSTS_CAMPAIGN}?${qs}`
    apiConfig.get(endPoint).then((response) => {
      const { data } = response;
      dispatch({
        type: CAMPAIGN_TYPE.POSTS,
        payload: data
      })
    }).catch((error) => {
      dispatch(setError(error.message))
    })
  };

export const deletePostCampaign = (fb_post_id, campaign_id) =>
  async (dispatch, getState) => {
    const { page } = getState();
    const params = {
      fb_page_id: page.social_id,
      fb_post_id,
      campaign_id,
      clientType: '',
      revision: '',
      languageCode: '',
      countryCode: '',
      timestamp: new Date().getTime()
    }
    dispatch(showLoading());
    apiConfigWthFormData.post(END_POINT.DELETE_POST_CAMPAIGN, params).then(() => {
      dispatch({
        type: CAMPAIGN_TYPE.DELETE_POSTS,
        payload: fb_post_id
      });
    }).catch((error) => {
      dispatch(setError(error.message))
    }).finally(() => {
      dispatch(hideLoading());
    });
  };

export const addProductCampaign = (products, id, callbackSuccess) =>
  async (dispatch) => {
    dispatch(showLoading());
    apiConfig.post(END_POINT.ADD_CAMPAIGN_PRODUCT, products).then(() => {
      dispatch(fetchProductCampaign(id));
      if (callbackSuccess) {
        callbackSuccess()
      }
    }).catch((error) => {
      dispatch(setError(error.message));
    }).finally(() => {
      dispatch(hideLoading());
    });
  }

export const fetchProductCampaign = (campaign_id) =>
  async (dispatch) => {
    dispatch(showLoading());
    const params = {
      campaign_id,
      clientType: '',
      revision: '',
      languageCode: '',
      countryCode: '',
      timestamp: new Date().getTime()
    }
    const qs = objToQueryString(params);
    const endPoint = `${END_POINT.LIST_PRODUCTS_CAMPAIGN}?${qs}`;

    apiConfig.get(endPoint).then((response) => {
      const { data } = response;
      dispatch({
        type: CAMPAIGN_TYPE.ADD_PRODUCTS,
        payload: data
      });
    }).catch((error) => {
      dispatch(setError(error.message))
    }).finally(() => {
      dispatch(hideLoading());
    });
  }

export const deleteProductCampaign = (array) =>
  async (dispatch) => {
    dispatch(showLoading());
    apiConfig.post(END_POINT.DELETE_CAMPAIGN_PRODUCT, array).then(() => {
      dispatch({
        type: CAMPAIGN_TYPE.DELETE_PRODUCTS,
        payload: array
      });
    }).catch((error) => {
      dispatch(setError(error.message))
    }).finally(() => {
      dispatch(hideLoading());
    });
  }

export const updateProductCampaign = (data) =>
  async (dispatch) => {
    dispatch(showLoading());
    apiConfig.post(END_POINT.UPDATE_CAMPAIGN_PRODUCT, data).then((response) => {
      dispatch({
        type: CAMPAIGN_TYPE.UPDATE_PRODUCT,
        payload: data
      });
    }).catch((error) => {
      dispatch(setError(error.message))
    }).finally(() => {
      dispatch(hideLoading());
    });
  }

export const commentPosts = (data) =>
  async (dispatch) => {
    dispatch(showLoading());
    apiConfig.post(END_POINT.COMMENT_POSTS, data).then((response) => {
      dispatch({
        type: CAMPAIGN_TYPE.UPDATE_PRODUCT,
        payload: data
      });
      showSuccessToasts('Đăng bình luận thành công');
    }).catch((error) => {
      dispatch(setError(error.message));
    }).finally(() => {
      dispatch(hideLoading());
    });
  }

export const getAllCampaign = (page = 1, page_size = 20, isFirst = true) =>
  async (dispatch, getState) => {
    const { page: pageFb } = getState();
    const params = {
      fb_page_id: pageFb.social_id,
      page,
      page_size
    }
    const qs = objToQueryString(params);
    const endPoint = `${END_POINT.GET_ALL_CAMPAIGN}?${qs}`;
    apiConfig.get(endPoint).then((response) => {
      dispatch({
        type: isFirst ? CAMPAIGN_TYPE.FETCHS : CAMPAIGN_TYPE.ADD_CAMPAIGNS,
        payload: response.data
      });
    }).catch((error) => {
      dispatch(setError(error.message));
    });
  }